export default __webpack_public_path__ + "static/media/2423.5b3d3dbf.png";